import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/inter/latin-300.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/cormorant-garamond/latin-400.css'
import '@fontsource/cormorant-garamond/latin-600.css'
import '@fontsource/cormorant-garamond/latin-700.css'
import './index.css'
import App from './App.jsx'

const BUILD_ID_KEY = 'ng-frontend-build-id'

async function reloadIfStaleBuild() {
  if (import.meta.env.DEV) return
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return
    const payload = await response.json()
    const id = String(payload?.id || '')
    if (!id) return
    const previous = window.sessionStorage.getItem(BUILD_ID_KEY)
    window.sessionStorage.setItem(BUILD_ID_KEY, id)
    if (previous && previous !== id) window.location.reload()
  } catch {
    // ignore réseau / JSON
  }
}

void reloadIfStaleBuild()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
